import React, { useCallback, useState } from 'react';
import { AnimatePresence, motion } from "framer-motion";

interface NfdColorsItemProps {
	color: string;
	colorCode: string;
}

const NfdColorsItemComponent = (props: NfdColorsItemProps) => {
	const [copied, setCopied] = useState(false);
	
	const copySVGToClipboard = useCallback(() => {
		navigator.clipboard.writeText(props.colorCode)
		.then(() => {
			setCopied(true);
			setTimeout(() => setCopied(false), 3000);
		})
		.catch((err) => console.error("Copy error:", err));
	}, []);
	
	return (
		<div className="nfdColorsItem">
			<div
				className={`nfdColorsItem_content ${props.color}`}
				style={{ background: `${props.colorCode}`}}
			>
				<span>{props.colorCode}</span>
			</div>
			<div className="nfdColorsItem_footer">
				<div className="nfdColorsItem_footer_text">
					<span>{props.color}</span>
				</div>
				<button className={`nfdColorsItem_footer_btn ${copied ? 'copied' : ''}`} onClick={copySVGToClipboard}>
					<div className="nfdColorsItem_footer_btn_content" >
						<AnimatePresence mode="wait">
							{copied ? (
								<motion.span
									key="copied"
									initial={{ y: 20, opacity: 0 }}
									animate={{ y: 0, opacity: 1 }}
									exit={{ y: -20, opacity: 0 }}
									transition={{ duration: 0.2 }}
								>
									<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
										<g clipPath="url(#clip0_1772_10513)">
											<path d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z" fill="#00BA00"/>
											<path fillRule="evenodd" clipRule="evenodd" d="M4.12605 8.92912L1.93864 6.57164C1.79353 6.41616 1.71602 6.20946 1.7231 5.9969C1.73019 5.78433 1.8213 5.58326 1.97644 5.43778C2.13254 5.29327 2.33959 5.21658 2.55216 5.22455C2.76473 5.23253 2.96546 5.3245 3.1103 5.4803L4.80164 7.28975L7.48038 4.78581C7.50431 4.76383 7.52955 4.74332 7.55597 4.7244L8.81266 3.54802C8.96814 3.40291 9.17484 3.32539 9.3874 3.33248C9.59997 3.33956 9.80104 3.43067 9.94652 3.58581C10.0916 3.7413 10.1691 3.948 10.1621 4.16056C10.155 4.37312 10.0639 4.5742 9.90872 4.71967L6.05833 8.31022L4.72132 9.55274L4.13077 8.91967L4.12605 8.92912Z" fill="white"/>
										</g>
										<defs>
											<clipPath id="clip0_1772_10513">
												<rect width="12" height="12" fill="white"/>
											</clipPath>
										</defs>
									</svg>
									Copied
								</motion.span>
							) : (
								<motion.span
									key="download"
									initial={{ y: 20, opacity: 0 }}
									animate={{ y: 0, opacity: 1 }}
									exit={{ y: -20, opacity: 0 }}
									transition={{ duration: 0.2 }}
								>
									Copy
								</motion.span>
							)}
						</AnimatePresence>
					</div>
				</button>
			</div>
		</div>
	);
};

export default NfdColorsItemComponent;